<ul>
  @for (tab of tabs; track tab) {
  <li (click)="selectTab(tab)" [class.active]="tab.active">
    <a>{{ tab.tabTitle }}</a>
  </li>
  }
</ul>
<ng-content></ng-content>
